import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import type { EmployeeOverviewData } from '@app/+authenticated/+employees/shared/employee-absence-overview/employee-absence-overview.model';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { parseDate } from '@shiftbase-com/ts-shared/utilities';
import { clsx } from 'clsx';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { getAuthenticatedUser, getEmployeeTeamDepartments } from '../../../reducers/orm/employee/employee.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'my-absence-component',
  template: `<employee-absence-overview [employee]="employee$ | async" />`,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  host: { '[class]': 'hostClasses' },
})
export class MyAbsenceComponent {
  private store = inject<Store<AppState>>(Store);
  employee$: Observable<EmployeeOverviewData>;

  hostClasses = clsx('block overflow-auto');

  constructor() {
    this.employee$ = this.store.select(getAuthenticatedUser).pipe(
      filter((user) => !!user),
      withLatestFrom(this.store.select(getEmployeeTeamDepartments)),
      map(([employee, employeeDepartments]) => ({
        id: employee.id,
        startYear: parseDate(employee.startdate).getFullYear().toString(),
        endDate: employee.enddate || '',
        departments: employeeDepartments[employee.id],
      })),
    );
  }
}
